import { api } from './api'

export const fetchRole = (query) => api.get('/role', query)

export const addRole = (role) => api.post('/role', role)

export const updateRole = (role) => api.put(`/role/${role.id}`, role)

export const deleteRole = ({ id }) => api.delete(`/role/${id}`)
